import React from 'react';
import { message, Button, Modal } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class AuditJDE extends React.Component {
    state = {
        loading: false,
    }

    hide = () => {
        this.props.hideAuditJDE();
    }

    resolveJDE = (type) => {
        const { auditJdeParams: { noticeId } } = this.props;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.handleJdeNotice,
            data: {
                type,
                noticeId
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.props.hideAuditJDE();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { loading } = this.state;
        const { auditJdeParams: { title1, title2, showAuditJDE } } = this.props;

        return (
            <Modal
                title="审批JDE主项目号"
                visible={showAuditJDE}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="400px"
                footer={[
                    <Button key="save" type="primary" loading={loading} onClick={() => this.resolveJDE("adopted")}>
                        同意
                </Button>,
                    <Button key="back" loading={loading} onClick={() => this.resolveJDE("not_adopted")}>拒绝</Button>,
                ]}
            >
                <div style={{ padding: '30px 40px' }}>
                    <div style={{ fontSize: "14px", wordBreak: "break-all", whiteSpace: "normal" }}>
                        <i className="anticon anticon-info-circle-o ant-alert-icon" style={{ color: "#108ee9", fontSize: "16px", top: "75px", left: "20px" }}></i>
                        {title1}
                    </div>
                    <div style={{ wordBreak: "break-all", whiteSpace: "normal", color: "#888", marginTop: "10px" }}>
                        {title2}
                    </div>
                </div>
            </Modal>

        );
    }
}

export default AuditJDE;



// WEBPACK FOOTER //
// ./src/components/layout/notice/AuditJDE.js